<button mat-icon-button routerLink="/ostukorv">
  <mat-icon [matBadge]="items" [matBadgeHidden]="!items" matBadgeColor="warn">shopping_cart</mat-icon>
</button>
